/**
 * 고객센터 (/m/setting/support) — 불러톡·전화 상담 버튼, 약관 링크
 * ($j.Pages.Mobile.SettingSupport / body data-page-name="SettingSupport")
 */
export default class SettingSupport {
    initialize() {
        $('.btn_box [data-href]').on('click', function () { location.href = this.dataset.href; });
        // 약관 — 서랍 메뉴와 같은 goMobileMenu(메뉴코드). 뒤로가기로 고객센터에 돌아온다
        $('.terms_box [data-menu]').on('click', function (e) {
            e.preventDefault();
            $j.F.Mobile.Layout.goMobileMenu(this.dataset.menu);
        });
    }
}
